/* eslint-disable no-case-declarations */
import { ajax } from "lib/observable";
import { Observable } from "rxjs";
import "rxjs/add/operator/map";
import {
    MUTATE_OPERATION_ENHANCED,
    WHITEBOARD_PAGE_SYNC,
    WHITEBOARD_PAGES_SYNC,
    WHITEBOARD_SYNC,
} from "constants/action-types";
import siteConfig from "site-config";
import { empty } from "rxjs/observable/empty";

const syncPageEpic = (payload) =>
    Observable.of(payload)
        .map((data) => {
            const operations = data.operations.map((operation) => {
                let operationPayload;
                switch (operation.operation) {
                    case "set":
                        const value = operation.value.toJS();
                        delete value.component; // this is something we add
                        operationPayload = {
                            key: {
                                component_id: operation.key,
                            },
                            value: {
                                page_component: value,
                            },
                        };
                        break;
                    case "remove":
                        operationPayload = {
                            key: {
                                component_id: operation.key,
                            },
                        };
                        break;
                    default:
                }

                if (!operationPayload) {
                    throw new Error(`Operation ${operation.operation} not implemented`);
                }
                return {
                    [operation.operation]: operationPayload,
                };
            });
            return { operations, data };
        })
        .map(({ operations, data }) => {
            const command = {
                operations,
                revision: parseInt(data.HEAD.revision, 10),
            };
            return { data, command };
        })
        .concatMap(({ command, data }) => {
            // Make it a queue, wait for response before continueing
            let url;
            switch (data.HEAD.object_type) {
                case "nuorder.service.board.page":
                    url = `/v1/boards/${data.HEAD.document_id}/pages/${payload.HEAD.object_id}/mutate`;
                    break;
                default:
            }
            return ajax({
                body: command,
                method: "POST",
                url: siteConfig.goAPI + url,
            })
                .map(() => ({
                    type: WHITEBOARD_PAGE_SYNC,
                }))
                .catch((error) => {
                    return Observable.of({
                        error: true,
                        payload: error,
                        type: WHITEBOARD_PAGE_SYNC,
                    });
                });
        });

const syncPagesEpic = (data) => {
    return Observable.of(data)
        .map((payload) => {
            const operations = data.operations.map((operation) => {
                let operationPayload;
                switch (operation.operation) {
                    case "insert":
                        operationPayload = {
                            index: operation.index,
                            value: operation.value.get("ref"),
                        };
                        break;
                    case "remove":
                        operationPayload = {
                            index: operation.index,
                        };
                        break;
                    case "move":
                        /**
                         * https://developers.google.com/google-apps/realtime/reference/gapi.drive.realtime.CollaborativeList.html#move
                         */
                        const { destination_index, index } = operation;
                        operationPayload = {
                            destination_index,
                            index,
                        };
                        break;
                    default:
                }

                if (!operationPayload) {
                    throw new Error(`Operation ${operation.operation} not implemented`);
                }
                return {
                    [operation.operation]: operationPayload,
                };
            });
            return { operations, payload };
        })
        .map(({ operations, payload }) => {
            const command = {
                operations,
                revision: parseInt(payload.HEAD.revision, 10),
            };
            return { payload, command };
        })
        .concatMap(({ command, payload }) => {
            // Make it a queue, wait for response before continueing
            const url = `/v1/boards/${payload.HEAD.document_id}/ref/pages/mutate`;
            return ajax({
                body: command,
                method: "POST",
                url: siteConfig.goAPI + url,
            })
                .map(() => ({ type: WHITEBOARD_PAGES_SYNC }))
                .catch((error) => {
                    return Observable.of({
                        error: true,
                        payload: error,
                        type: WHITEBOARD_PAGES_SYNC,
                    });
                });
        });
};

const syncBoardEpic = (payload) =>
    Observable.of(payload)
        .map((data) => {
            const operations = data.operations.map((operation) => {
                let operationPayload;
                switch (operation.operation) {
                    case "set":
                        const value = operation.value.toJS();
                        const key = operation.key.toString();
                        const dataType = Object.keys(value)[0];
                        operationPayload = {
                            [key]: value[dataType],
                        };
                        break;
                    default:
                }

                if (!operationPayload) {
                    throw new Error(`Operation ${operation.operation} not implemented`);
                }
                return {
                    [operation.operation]: operationPayload,
                };
            });
            return { operations, data };
        })
        .map(({ operations, data }) => {
            const command = {
                operations,
                revision: parseInt(data.HEAD.revision, 10),
            };
            return { data, command };
        })
        .concatMap(({ command, data }) => {
            // Make it a queue, wait for response before continueing
            let url;
            switch (data.HEAD.object_type) {
                case "nuorder.service.board":
                    url = `/v1/boards/${data.HEAD.document_id}/ref/properties/mutate`;
                    break;
                default:
            }
            return ajax({
                body: command,
                method: "POST",
                url: siteConfig.goAPI + url,
            })
                .map(() => ({
                    type: WHITEBOARD_SYNC,
                }))
                .catch((error) => {
                    return Observable.of({
                        error: true,
                        payload: error,
                        type: WHITEBOARD_SYNC,
                    });
                });
        })
        .catch((error) => {
            return Observable.of({
                error: true,
                payload: error,
                type: WHITEBOARD_SYNC,
            });
        });

export const syncEpic = (action$) => {
    return action$
        .ofType(MUTATE_OPERATION_ENHANCED)
        .filter(
            ({
                payload: {
                    HEAD: { namespace },
                },
            }) => namespace === "nuorder.service.board"
        )
        .concatMap(({ payload }) => {
            switch (payload.HEAD.object_type) {
                case "nuorder.service.board.page":
                    return syncPageEpic(payload);
                case "nuorder.service.board.pages":
                    return syncPagesEpic(payload);
                case "nuorder.service.board":
                    return syncBoardEpic(payload);
                default:
                    return empty();
            }
        });
};
